<template>
	<LayoutBase>
		<template v-if="!$wait.is('fetching preview resource')">
			<section class="preview-section">
				<header class="preview-section__header">
					<h2 class="h1">Insight</h2>
					<router-link :to="stepLink(1)" class="btn" v-if="canCompleteStep(1)">Edit</router-link>
				</header>

				<template v-if="completedStep(1)">
					<h2>{{ resource.name }}</h2>
					<ul class="grid post-details">
						<li v-if="resource.sectors" class="col-12 detail">
							<span class="label">Sectors</span>
							<span class="sector" v-for="sector in resource.sectors">{{ sector.name }}</span>
						</li>
					</ul>
				</template>

				<p v-else>Not completed</p>
			</section>
			<section class="preview-section">
				<header class="preview-section__header">
					<h2 class="h1">Category</h2>
					<router-link :to="stepLink(2)" class="btn" v-if="canCompleteStep(2)">Edit</router-link>
				</header>

				<template v-if="completedStep(2)">
					<ul class="grid post-details">
						<li v-if="resource.category" class="col-3 detail">
							<span class="label">Category</span>
							<span class="h3"><SvgIcon :icon="'category'"/> {{ resource.category.name }}</span>
						</li>
					</ul>
				</template>

				<p v-else>Not completed</p>
			</section>
			<section class="preview-section">
				<header class="preview-section__header">
					<h2 class="h1">Content</h2>
					<router-link :to="stepLink(3)" class="btn" v-if="canCompleteStep(3)">Edit</router-link>
				</header>

				<template v-if="completedStep(3)">
					<ul class="grid post-details">
						<li v-if="resource.type" class="col-3 detail">
							<span class="label">Content Type</span>
							<span class="h3">{{ resource.type }}</span>
						</li>
					</ul>
					<div class="card" style="margin-top: 2rem;" v-if="resource.description">
						<div class="header">Description</div>
						<div v-html="resource.description"></div>
					</div>
					<div class="card" v-if="resource.attachments">
						<div class="header">Attachments</div>
						<ul class="documents" v-if="resource.attachments.length">
							<li v-for="doc in resource.attachments">
								<AttachmentDownload :attachment="doc"></AttachmentDownload>
							</li>
						</ul>
					</div>
				</template>

				<p v-else>Not completed</p>
			</section>

			<div class="form">
				<div class="form__group form__group--submit-fixed">
					<button @click="showDeleteModal()" class="btn btn--danger" v-if="resource.can.delete"
					        v-wait:disabled="['saving preview resource', 'deleting preview resource']">
						Delete Insight
					</button>
					<router-link tag="button" :to="{ name: 'view-document', params: { insight_id: resource.id }}"
					             class="btn" v-wait:disabled="'saving preview resource'">
						Save and Leave
					</router-link>
					<button @click="saveResource(2)" class="btn btn--primary btn--no-stretch"
					        v-wait:disabled="'saving preview resource'" v-if="resource.can.submit">
						Post Insight
					</button>
				</div>
			</div>
		</template>
	</LayoutBase>
</template>

<script>
	import LayoutBase from '../Layout/LayoutBase';
	import API from '../../api';
	import SvgIcon from '../SvgIcon';
	import ResourcePreview from '../ResourcePreview';
    import AttachmentDownload from '../AttachmentDownload';

	export default {
		name: 'InsightPreview',
		mixins: [ResourcePreview],
		components: {
            AttachmentDownload,
			LayoutBase,
			SvgIcon,
		},
		data() {
			return {
				deleteModal: {
					title: 'Are you sure you want to delete this Insight?',
					buttonLabel: 'Delete Insight',
				},
			};
		},
		methods: {
			stepLink(step) {
				return { name: 'edit-document-step', params: { insight_id: this.id, step: step }};
			},
			fetchResource() {
				return API.getInsight(this.id);
			},
			updateResource(status) {
				return API.updateInsight(this.id, null, {status: status}).then(response => {
					this.$router.push({
						name: 'view-document',
						insight_id: response.id,
					});
				});
			},
			deleteResource() {
				return API.deleteInsight(this.id).then(() => {
					this.$router.push({ name: 'insights' });
				});
			},
		},
	}
</script>
